import styled, { css } from 'styled-components'

export default styled.div`
    background: ${(props) => props.accent};
    content: '';
    height: 820px;
    position: absolute;
    width: 50%;

    ${(props) =>
        props.right
            ? css`
                  bottom: 0;
                  clip-path: polygon(100% 100%, 100% 0, 0 100%);
                  right: 0;
              `
            : css`
                  clip-path: polygon(100% 0, 0 0, 0 100%);
                  left: 0;
                  top: 0;
              `};
`
